import * as ko from "knockout";
import * as moment from 'moment';
import * as _ from 'underscore';

import Moment = moment.Moment;

// Models
import { AddressType } from "Content/ts/Models/Shared/Enums/addressTypes";

export class ContactDetails {
    Title: KnockoutObservable<string>;
    FirstName: KnockoutObservable<string>;
    LastName: KnockoutObservable<string>;
    EmailAddress: KnockoutObservable<string>;
    DateOfBirth: KnockoutObservable<Moment>;
    GenderId: KnockoutObservable<number>;
    EthnicOriginId: KnockoutObservable<number>;
    Occupation: KnockoutObservable<string>;
    Employer: KnockoutObservable<string>;
    EmergencyName: KnockoutObservable<string>;
    EmergencyPhone: KnockoutObservable<string>;
    EmergencyTwoName: KnockoutObservable<string>;
    EmergencyTwoPhone: KnockoutObservable<string>;
    ReferringMember: KnockoutObservable<string>;
    MarketingSourceId: KnockoutObservable<number>;

    Addresses: AddressDetails[];

    constructor() {
        this.Title = ko.observable();
        this.FirstName = ko.observable(null);
        this.LastName = ko.observable(null);
        this.DateOfBirth = ko.observable();
        this.EmailAddress = ko.observable(null);
        this.GenderId = ko.observable();
        this.EthnicOriginId = ko.observable(null);
        this.Occupation = ko.observable(null);
        this.Employer = ko.observable(null);
        this.MarketingSourceId = ko.observable();
        this.ReferringMember = ko.observable(null);
        this.EmergencyName = ko.observable(null);
        this.EmergencyPhone = ko.observable(null);
        this.EmergencyTwoName = ko.observable(null);
        this.EmergencyTwoPhone = ko.observable(null);
        

        this.Addresses = [new AddressDetails(AddressType.Home)];
    }

    getAddressDetailsForType(addressType: AddressType): AddressDetails {
        return this.Addresses.find(a => a.AddressTypeId === addressType);
    }
}

export class AddressDetails {
    AddressTypeId: number;
    AddressLine1: KnockoutObservable<string>;
    AddressLine2: KnockoutObservable<string>;
    City: KnockoutObservable<string>;
    County: KnockoutObservable<string>;
    Country: KnockoutObservable<string>;
    Postcode: KnockoutObservable<string>;
    Phone: KnockoutObservable<string>;

    constructor(addressType: AddressType = AddressType.Home) {
        this.AddressTypeId = addressType;
        this.AddressLine1 = ko.observable(null);
        this.AddressLine2 = ko.observable(null);
        this.City = ko.observable(null);
        this.County = ko.observable(null);
        this.Country = ko.observable(null);
        this.Postcode = ko.observable(null);
        this.Phone = ko.observable(null);
    }
}